<template lang="pug">
	//- Служебное сообщение агента: вызов инструмента, статистика работы или распознанное голосовое сообщение
	.ai-chat-message-service(v-if="type === 'tool'" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'AI agent is using a tool'}")
		i.fa.fa-wrench
		span {{message.message}}
	.ai-chat-message-service(v-else)
		i.fa(:class="type === 'stats' ? 'fa-bar-chart' : 'fa-microphone'")
		span {{message.message}}
</template>

<script>
	export default {
		name: "AIAgentMessageService",
		// type: 'tool' | 'stats' | 'voice'
		props: ['message', 'type']
	}
</script>

<style lang="sass">

	.ai-chat
		.ai-chat-history
			.ai-chat-message
				// Служебные сообщения агента: вызовы инструментов и статистика - компактные строки без фона
				&.tool
					margin-bottom: 4px

				&.stats
					margin-bottom: 14px

				.ai-chat-message-service
					display: flex
					flex-direction: row
					align-items: baseline
					gap: 8px
					max-width: 80%
					padding: 2px 10px
					font-size: 13px
					line-height: 16px
					color: #73818f
					word-break: break-all

					i.fa
						flex: 0 0 auto
						font-size: 11px

				&.tool
					.ai-chat-message-service
						font-family: monospace

				&.stats, &.voice
					.ai-chat-message-service
						color: #adb6bf
						font-style: italic

				&.voice
					margin-bottom: 4px

</style>
